import * as React from 'react'
import { fromJSX } from 'widgets-for-react'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import { DP } from '../../../drupal/blockDefinitions'
import { dummyData, randomTitle, randomWords } from '../../../utils/dummyData'
import { linkWrapper, removeLanguageFromLinkStart } from '../../../utils/link'
import { ModernBlock } from '../../modernBlocks.state'
import { linkListBlockClasses, LinkListBlockLayout } from './linkListBlock.layout'
import { LinkListBlockProps, LinkListItem } from './linkListBlock.state'

export const linkListBlock: ModernBlock<LinkListBlockProps, any, any, DP.LinkList> = {
  kind: 'linkListBlock',
  render: (setRootState, rootState, blockIndex, blockProps, amountNested) =>
    fromJSX((updateBlock) => (
      <LinkListBlockLayout.Inner amountNested={amountNested!}>
        <LinkListBlockLayout.Content
          label={blockProps.label}
          title={blockProps.title}
          intro={blockProps.intro}
          items={blockProps.items}
          showPrimary={blockProps.showPrimary}
          showSecondary={blockProps.showSecondary}
          primaryAction={blockProps.primaryAction!}
          secondaryAction={blockProps.secondaryAction!}
        />
      </LinkListBlockLayout.Inner>
    )),
  blockClassName: getClassNameModern(linkListBlockClasses, 'block', 'mb-6'),
  inView: {
    showAs: 'section',
    threshold: 0.1,
    triggerOnce: true,
    inViewClassName: getClassNameModern(linkListBlockClasses, 'inview', 'inview'),
    updateState: (currentInviewState, currentBlockState) => {
      return {
        ...currentBlockState,
        inviewState: currentInviewState,
      }
    },
  },
  adapters: {
    drupal: (dpBlock: DP.LinkList, blockIndex: number) => {
      const target = dpBlock.target.type[0].target_id
      if (target != 'links_list') return undefined
      return {
        index: blockIndex,
        title: dpBlock.target.field_title ? dpBlock.target.field_title[0]?.value : undefined,
        label: dpBlock.target.field_label ? dpBlock.target.field_label[0]?.value : undefined,
        intro: dpBlock.target.field_introduction ? dpBlock.target.field_introduction[0]?.value : undefined,
        showPrimary: dpBlock.target?.field_links[0] ? true : false,
        showSecondary: dpBlock.target?.field_links[1] ? true : false,
        excludeFromPageMenu: dpBlock.target?.field_exclude_from_page_menu?.[0]?.value,
        primaryAction: linkWrapper({
          title: dpBlock.target?.field_links ? dpBlock.target?.field_links[0]?.title! : '',
          url: dpBlock.target?.field_links ? dpBlock.target?.field_links[0]?.processed_url! : '',
          anchor: dpBlock.target?.field_links ? dpBlock.target?.field_links[0]?.options?.attributes?.id! : '',
        }),
        secondaryAction: linkWrapper({
          title: dpBlock.target?.field_links ? dpBlock.target?.field_links[1]?.title! : '',
          url: dpBlock.target?.field_links ? dpBlock.target?.field_links[1]?.processed_url! : '',
          anchor: dpBlock.target?.field_links ? dpBlock.target?.field_links[1]?.options?.attributes?.id! : '',
        }),
        items:
          dpBlock.target.field_links_list?.map((block, i) => ({
            subTitle: block.target.field_text ? block.target.field_text[0]?.value : '',
            link: linkWrapper({
              title: block.target.field_url ?  block.target.field_url[0]?.title : '',
              url: removeLanguageFromLinkStart(block.target.field_url ?  block.target.field_url[0]?.processed_url : ''),
              anchor: block.target?.field_url ? block.target?.field_url[0]?.options?.attributes?.id : '',
            }),
            key: `link-list-${blockIndex}-item-${i}`,
          })) || [],
        anchorTitle: dpBlock.target.field_title[0]?.value,
      }
    },
  },
  seoEvents: (props, blockIndex) =>
    props.items?.map((item, index) => ({
      id: `link-item-${index}`,
      event: 'onClick',
      category: 'linklist',
      label: window.location.pathname,
      action: item.link.title,
    })) || [],
  sampleExample: [
    {
      index: 0,
      label: randomWords(),
      title: randomTitle(),
      intro: dummyData.intro,
      showPrimary: true,
      showSecondary: true,
      primaryAction: dummyData.primaryButton,
      secondaryAction: dummyData.secondaryButton,
      anchorTitle: 'linklist-sample-1',
      items: [
        {
          key: 'll-i1',
          subTitle: randomTitle(),
          link: linkWrapper({ title: randomTitle(), url: 'https://www.hoppinger.com' }),
        },
        {
          key: 'll-i2',
          subTitle: randomTitle(),
          link: linkWrapper({ title: randomTitle(), url: 'https://www.viddadigital.com' }),
        },
        {
          key: 'll-i3',
          subTitle: '',
          link: linkWrapper({ title: randomTitle(), url: '/' }),
        },
      ],
    },
  ],
}
